import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldInputSelect } from "@/components/FormFields/FormFieldInputSelect/FormFieldInputSelect";
import { type FormSelectChoice, type InputSelectComponentProps } from "@/lib/types/types";

export const CountryComponent = ({
  value,
  isErrored,
  options,
  onChange,
  onKeyDown,
  placeholder = "",
  isRequired = true,
  suppressPlaceholder = false,
  disabled = false,
}: InputSelectComponentProps) => {
  const { msg } = useMessage();
  const inputId = "country";
  return (
    <FormFieldInputSelect
      fieldId={inputId}
      options={options}
      onChange={(country: FormSelectChoice) => onChange(country)}
      onKeyDown={onKeyDown}
      placeholder={placeholder || msg({ id: "countryPlaceholder" })}
      value={options.find((option) => option.value === (value && value.value))}
      isRequired={isRequired}
      label={<FormattedHTMLMessage id="country" defaultMessage="Country" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidCountry" defaultMessage="Invalid country" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      suppressPlaceholder={suppressPlaceholder}
      disabled={disabled}
    />
  );
};
